import React from 'react';
import { Field } from 'redux-form';
import { FormSelect } from '../../FormSelect';
import Row from '../../Row';
import PropTypes from 'prop-types';
import Alert from 'react-s-alert';
import { FormText } from '../../FormText';
import { ResourceContractorSchemaListRequest } from './ResourceContractorSchemaListRequest';
import { buildOptions } from '../../../utils/OptionsManager';
import './ResourceContractorSchemas.css';
import { ResourceContractorSchemaAsCompanyListTask } from './ResourceContractorSchemaAsCompanyListTask';
import { QrWorkerTokenRequest } from './worker-qr/QrWorkerTokenRequest';
import { QrWorkerTokenTask } from './worker-qr/QrWorkerTokenTask';
import { PsQrWorkerToken } from '../../../../my-outsources/worker/PsQrWorkerToken';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import LinkButton from '../../LinkButton';
import { Modal } from 'react-bootstrap';
import QRCode from 'react-qr-code';
import { QrMachineTokenTask } from './machine-qr/QrMachineTokenTask';
import { QrMachineTokenRequest } from './machine-qr/QrMachineTokenRequest';
import { PsQrMachineToken } from '../../../../my-outsources/machine/PsQrMachineToken';
import DocumentSchemaType from '../../../model/DocumentSchemaType';

export class ResourceContractorSchemas extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            qrFields: [],
            currentQrToken: '',
            showQrModal: false,
        };
    }

    componentDidMount() {
        this.listContractorSchemas();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {
            refreshQrToken,
            handleSetRefreshQrToken,
            workerId,
            machineId,
        } = this.props;

        if ( refreshQrToken && refreshQrToken !== prevState.refreshQrToken ) {
            handleSetRefreshQrToken(false);
            if ( workerId ) {
                this.getQrWorkerToken();
            }
            if ( machineId ) {
                this.getQrMachineToken();
            }
        }
    }

    handleShowQr = (qrToken) => {
        this.setState({
            currentQrToken: qrToken,
            showQrModal: true,
        });
    };

    render() {
        const {
            fields,
            showPositionField,
            contractorManagerDisabledFields,
            documentSchemaType,
        } = this.props;
        const { qrFields } = this.state;
        const disabledWorker = documentSchemaType === DocumentSchemaType.WORKER && contractorManagerDisabledFields;

        return fields.map((fieldName, index) => {
            const field = fields.get(index);
            const qrField = qrFields.find(qrField => qrField.fieldIndex === index);
            const qrToken = qrField ? qrField.qrToken : null;

            return (
                <div
                    key={fieldName}
                    className={'component-resource-contractor-schemas'}
                >
                    <Row className="ps-schema-row">
                        <Field
                            col="col-md-6"
                            name={`${fieldName}.contractor`}
                            disabled={true}
                            component={FormText}
                        />
                    </Row>
                    <Row className="ps-schema-row">
                        <Field
                            col="col-sm-6"
                            name={`${fieldName}.schema`}
                            options={field.schemaOptions}
                            displayEmptyOption={true}
                            component={FormSelect}
                        />
                        {
                            showPositionField &&
                            <Field
                                col="col-sm-4"
                                name={`${fieldName}.position`}
                                component={FormText}
                                placeholder={I18nUtils.tr('TR_INTRODUCE_EL_OFICIO_SEGUN_FORMACION_CONVENIO')}
                                disabled={disabledWorker}
                            />
                        }
                        {
                            qrToken &&
                            <div className="col-sm-2">
                                <div onClick={() => this.handleShowQr(qrToken)}>
                                    <LinkButton
                                        to={() => null}
                                        text={I18nUtils.tr('TR_VER_QR')}
                                        className={'btn-block btn-sm bold'}
                                    />
                                </div>
                            </div>
                        }
                        {this.renderQrModal()}
                    </Row>
                </div>
            );
        });
    }

    renderQrModal() {
        const {
            workerId,
        } = this.props;
        const {
            showQrModal,
            currentQrToken,
        } = this.state;

        const title = workerId ? 'TR_DATOS_DEL_TRABAJADOR' : 'TR_DATOS_DE_LA_MAQUINA';

        return (
            <Modal
                show={showQrModal}
                onHide={() => this.setState({ showQrModal: false })}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-sm">
                        {I18nUtils.tr(title)}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={'qr-modal-body'}>
                        <QRCode
                            value={currentQrToken}
                            size={256}
                        />
                    </div>
                </Modal.Body>
            </Modal>
        );
    }

    listContractorSchemas = () => {
        const { documentSchemaType } = this.props;
        const request = new ResourceContractorSchemaListRequest(documentSchemaType);
        new ResourceContractorSchemaAsCompanyListTask(request)
            .onSuccess((res) => {
                this._pushContractorSchemas(res.data);
                // this._pushContractorSchemas(contractorSchemasStubs);
            })
            .onFail(error => Alert.error(error))
            .execute();
    };

    _pushContractorSchemas = (contractors) => {
        const {
            fields,
            initialValues,
            workerId,
            machineId,
        } = this.props;

        contractors.forEach((contractor) => {
            const alreadyPushedContractor = initialValues
                .contractorSchemas
                .find((cs) => cs.contractorId === contractor.id);

            if ( alreadyPushedContractor ) {
                alreadyPushedContractor.schemaOptions = buildOptions(contractor.document_schemas);
            } else {
                fields.push({
                    contractorId: contractor.id,
                    contractor: contractor.name,
                    schema: [],
                    schemaOptions: buildOptions(contractor.document_schemas),
                });
            }
        });

        if ( workerId ) {
            this.getQrWorkerToken();
        }
        if ( machineId ) {
            this.getQrMachineToken();
        }

        this.forceUpdate();
    };

    getQrWorkerToken = () => {
        const {
            fields,
            workerId,
            handleTokenLoading,
        } = this.props;

        const request = new QrWorkerTokenRequest();

        fields.forEach((field, fieldIndex) => {
            request.setContractorId(fields.get(fieldIndex).contractorId);
            request.setId(workerId);

            handleTokenLoading(true);
            new QrWorkerTokenTask(request)
                .onSuccess(res => {
                    const qrWorkerToken = PsQrWorkerToken.fromApiQrWorkerToken(res.data);
                    const qrField = {
                        fieldIndex: fieldIndex,
                        qrToken: qrWorkerToken.qrInfo(),
                    };
                    this.setState({ qrFields: [...this.state.qrFields, qrField] });
                    handleTokenLoading(false);
                })
                .onFail(error => Alert.error(error))
                .execute();
        });
    };

    getQrMachineToken = () => {
        const {
            fields,
            machineId,
            handleTokenLoading,
        } = this.props;

        const request = new QrMachineTokenRequest();

        fields.forEach((field, fieldIndex) => {
            request.setContractorId(fields.get(fieldIndex).contractorId);
            request.setId(machineId);

            handleTokenLoading(true);
            new QrMachineTokenTask(request)
                .onSuccess(res => {
                    const qrMachineToken = PsQrMachineToken.fromApiQrMachineToken(res.data);
                    const qrField = {
                        fieldIndex: fieldIndex,
                        qrToken: qrMachineToken.qrInfo(),
                    };
                    this.setState({ qrFields: [...this.state.qrFields, qrField] });
                    handleTokenLoading(false);
                })
                .onFail(error => Alert.error(error))
                .execute();
        });
    };
}

ResourceContractorSchemas.propTypes = {
    fields: PropTypes.any,
    initialValues: PropTypes.number.isRequired,
    documentSchemaType: PropTypes.number.isRequired,
    workerId: PropTypes.number,
    machineId: PropTypes.number,
    handleSetRefreshQrToken: PropTypes.func,
    refreshQrToken: PropTypes.bool,
    handleTokenLoading: PropTypes.func,
    showPositionField: PropTypes.bool,
    contractorManagerDisabledFields: PropTypes.bool,
};

ResourceContractorSchemas.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/shared/components/predefined-fields/resource-contractor-schema/ResourceContractorSchemas.jsx